import { render, staticRenderFns } from "./ContentText.vue?vue&type=template&id=2de41e1e&scoped=true&"
import script from "./ContentText.vue?vue&type=script&lang=js&"
export * from "./ContentText.vue?vue&type=script&lang=js&"
import style0 from "./ContentText.vue?vue&type=style&index=0&id=2de41e1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de41e1e",
  null
  
)

export default component.exports